import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "skycore_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Fetch a short-lived, single-purpose token for opening WebSocket bridges.
export async function getWsToken() {
  const { data } = await api.post("/auth/ws-token");
  return data.ws_token;
}

export function buildWsUrl(path, token) {
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}${path}?token=${token}`;
}

export function apiErr(e, fallback = "Une erreur est survenue") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return fallback;
}
